/**
 * Local Storage Service — GenesisBox
 * Thin wrapper with error handling and prefix namespacing.
 */

import { STORAGE_PREFIX } from '@config/constants';

function prefixed(key: string): string {
  return key.startsWith(STORAGE_PREFIX) ? key : `${STORAGE_PREFIX}:${key}`;
}

export function getItem(key: string): string | null {
  try { return localStorage.getItem(prefixed(key)); }
  catch { return null; }
}

export function setItem(key: string, value: string): void {
  try { localStorage.setItem(prefixed(key), value); }
  catch { /* quota exceeded, etc. */ }
}

export function removeItem(key: string): void {
  try { localStorage.removeItem(prefixed(key)); }
  catch { /* noop */ }
}
